<template>
  <!-- 客户自主填写信息 -->
  <bk-page class="addCustomerProfilePage" pageType="navPage" :navBarInfo="navBarInfo">
		<bk-view class="view-box" :loading="loadView==='view'">

			<template v-if="customizeList.length">
				<bk-view class="view-header-main">
					<bk-lang code="addCustomerProfile_fillOutYourInformation"></bk-lang>
					<bk-view class="view-language-main" @click="setShowPage('languageConfig')">{{ getLanguageText() }}<bk-icon icon="icon-xiajiantou" /></bk-view>
				</bk-view>
				<bk-view class="view-form-main">
					<template v-for="groupItem in customizeList" :key="groupItem.key">
						<bk-view class="view-group" v-if="groupItem.key==='base'">
							<bk-view class="view-list">
								<template v-for="listItem in groupItem.list" :key="listItem.key">
									<bk-view v-if="listItem.key==='firstName'" class="view-item" :class="[listItem.className]">
										<bk-first-last 
											v-model:firstName="formData.firstName"
											v-model:lastName="formData.lastName"
										/>
									</bk-view>
									<bk-view class="view-item" :class="[listItem.className]" v-if="listItem.key==='mobile' && dictInfo.intMobileCd">
										<bk-formItem langCode_label="addCustomerProfile_phoneNumber">
											<template v-slot>
												<phoneInput
													:dataList="dictInfo.intMobileCd"
													v-model="formData.mobile"
													v-model:intMobileCd="formData.mobileCdValue"
													v-model:intMobileCode="formData.mobileCdCode"
													@inputChange="verifyPhone"
													@change="verifyPhone"
												/>
												<bk-view class="item-error-tip">{{mobileErrorText}}</bk-view>
											</template>
										</bk-formItem>
									</bk-view> 
									<bk-view class="view-item" :class="[listItem.className]" v-if="listItem.key==='email'">
										<bk-input
											v-model:value="formData.email"
											langCode_label="addCustomerProfile_email"
											@change="verifyEmail"
										/>
										<bk-view class="item-error-tip">{{emailErrorText}}</bk-view>
									</bk-view>
									<bk-view class="view-item" :class="[listItem.className]"  v-if="listItem.key==='gender'">
										<bk-field-select type="choose" v-model="formData.gender" :dataList="genderList" langCode_label="addCustomerProfile_gender"  />
									</bk-view>
									<bk-view class="view-item" :class="[listItem.className]" v-if="listItem.key==='birthday'">
										<bkSelectBirthday
											v-model:birthMd="formData.birthMd"
											v-model:birthYear="formData.birthYear"
										/>
									</bk-view>
									<bk-view class="view-item" :class="[listItem.className]" v-if="listItem.key==='preferLangCode'">
										<bk-field-select 
											type="choose" 
											v-model="formData.preferLangCode" 
											:dataList="preferLangCodeList" 
											langCode_label="addCustomerProfile_preferredNotificationLanguage"  
										/>
									</bk-view>
								</template>
							</bk-view>
						</bk-view>
						<bk-view class="view-group" v-if="groupItem.key==='outer'">
							<bk-lang class="view-title" code="addCustomerProfile_otherInfo"></bk-lang>
							<bk-view class="view-list">
								<template v-for="listItem in groupItem.list" :key="listItem.key">

									<bk-view class="view-item" :class="[listItem.className]" v-if="listItem.key==='insuranceCompanyCode'">
										<bkAutoComplete
											v-model:value="formData.insuranceCompanyCode"
											v-model:label="formData.insuranceCompanyText"
											:dataList="baseInfo.BX"
											langCode_label="addCustomerProfile_insuranceCompany"
										/>
									</bk-view>
									<bk-view class="view-item" :class="[listItem.className]"  v-if="listItem.key==='insuranceCardNo'">
										<bk-input v-model:value="formData.insuranceCardNo" langCode_label="addCustomerProfile_insuranceCardNumber" />
									</bk-view>
									<bk-view class="view-item" :class="[listItem.className]" v-if="listItem.key==='arriveSourceCode'">
										<bk-field-select 
											type="choose" 
											v-model="formData.arriveSourceCode" 
											:dataList="baseInfo.CS" 
											langCode_label="addCustomerProfile_clientSource"  
										/>
									</bk-view>
									<bk-view class="view-item" :class="[listItem.className]" v-if="listItem.key==='nationalityCode'">
										<bk-field-select 
											type="choose" 
											v-model="formData.nationalityCode" 
											:dataList="countryList" 
											langCode_label="addCustomerProfile_nationality"  
										/>
									</bk-view>
									<bk-view class="view-item" :class="[listItem.className]" v-if="listItem.key==='raceText'">
										<bk-input v-model:value="formData.raceText" langCode_label="addCustomerProfile_ethnicity" />
									</bk-view>
									<bk-view class="view-item" :class="[listItem.className]" v-if="listItem.key==='religionCode'">
										<bk-field-select 
											type="choose" 
											v-model="formData.religionCode" 
											langCode_label="addCustomerProfile_religion" 
											:dataList="religionList"
										/>
									</bk-view>
									<bk-view class="view-item" :class="[listItem.className]" v-if="listItem.key==='identityId'">
										<bk-input v-model:value="formData.identityId" langCode_label="addCustomerProfile_idPassport" />
									</bk-view>
									<bk-view class="view-item" :class="[listItem.className]" v-if="listItem.key==='emergency'">
										<bk-input v-model:value="formData.emergency" langCode_label="addCustomerProfile_emergencyContact" />
									</bk-view>
									<bk-view class="view-item" :class="[listItem.className]" v-if="listItem.key==='emergencyMobile' && dictInfo.intMobileCd">
										<bk-formItem langCode_label="addCustomerProfile_emergencyContactnumber">
											<template v-slot>
												<phoneInput
													:dataList="dictInfo.intMobileCd"
													v-model="formData.emergencyMobile"
													v-model:intMobileCd="formData.emergencyMobileCdValue"
													v-model:intMobileCode="formData.emergencyMobileCdCode"
												/>
											</template>
										</bk-formItem>
									</bk-view> 
									<bk-view class="view-item" :class="[listItem.className]" v-if="listItem.key==='address'">
										<bk-input v-model:value="formData.address" langCode_label="addCustomerProfile_homeAddress" />
									</bk-view>
									<bk-view class="view-item" :class="[listItem.className]" v-if="listItem.key==='occupation'">
										<bk-input v-model:value="formData.occupation" langCode_label="addCustomerProfile_occupation" />
									</bk-view>
								</template>
							</bk-view>
						</bk-view>
						<bk-view class="view-group" v-if="groupItem.key==='social'">
							<bk-lang class="view-title" code="addCustomerProfile_socialMedia"></bk-lang>
							<bk-view class="view-list">
								<template v-for="listItem in groupItem.list" :key="listItem.key">
									<bk-view class="view-item" :class="[listItem.className]" v-if="listItem.key==='whatsApp'">
										<bk-input 
											v-model:value="formData.whatsApp" 
											langCode_label="addCustomerProfile_whatsApp" 
											langCode_placeholder="addCustomerProfile_pleasEnterWhatsApp"
											prefixImg="Def_Icon_Clients_WhatsApp.png" 
										/>
									</bk-view>
									<bk-view class="view-item" :class="[listItem.className]" v-if="listItem.key==='facebook'">
										<bk-input 
											v-model:value="formData.facebook" 
											langCode_label="addCustomerProfile_facebook" 
											langCode_placeholder="addCustomerProfile_pleasEnterFacebook"
											prefixImg="Def_Icon_Clients_Facebook.png" 
										/>
									</bk-view>
									<bk-view class="view-item" :class="[listItem.className]" v-if="listItem.key==='instagram'">
										<bk-input 
											v-model:value="formData.instagram" 
											langCode_label="addCustomerProfile_Ins" 
											langCode_placeholder="addCustomerProfile_pleasEnterInstagram"
											prefixImg="Def_Icon_Clients_Instagram.png" 
										/>
									</bk-view>
									<bk-view class="view-item" :class="[listItem.className]" v-if="listItem.key==='wechatAccount'">
										<bk-input 
											v-model:value="formData.wechatAccount" 
											langCode_label="addCustomerProfile_weChat" 
											langCode_placeholder="addCustomerProfile_msg_weChat"
											prefixImg="Def_Icon_Clients_WeChat.png" 
										/>
									</bk-view>
								</template>
							</bk-view>
						</bk-view>
					</template>
				</bk-view>
				<bk-view class="view-footer">
					<bk-button langCode="global_button_save" :loading="loadView==='save'" @click="handleSave()"></bk-button>
				</bk-view>
			</template>
		</bk-view>
		
		<transition name="rightFadeIn">
			<languageConfig v-if="showPage==='languageConfig'" :reloadPath="reloadPath" @close="setShowPage()" />
    </transition>
  </bk-page>
</template>

<script>
	import phoneInput from '@/pages/login/signup/phoneInput/phoneInput.vue';
	import bkFirstLast from '@/components/bk-business/bk-first-last/bk-first-last.vue';
	import bkAutoComplete from '@/components/bk-business/bk-autoComplete/bk-autoComplete.vue';
	import bkSelectBirthday from '@/components/bk-business/bk-selectBirthday/bk-selectBirthday.vue';
	import languageConfig from '@/pages/userInfo/subPages/languageConfig/languageConfig.vue';
	import { customerReq, shopReq, baseReq, authReq } from '@/reqService';
	import dayjs from 'dayjs';

	let isInitlanguage = false;
  
	export default {
		name:'addCustomerProfile',
		components:{ 
			phoneInput, bkFirstLast, languageConfig, bkAutoComplete,
			bkSelectBirthday
		},
		data (){
			const { baseConstantInfo, } = this.$bk_Global;
			const { genderList, religionList } = baseConstantInfo; 
		
			return {
				navBarInfo:{
					backFlag: false, 
				},
				formData:{},
				genderList,
				dictInfo:{},
				loadView:'',
				systemInfo:{},
				curShop:{},
				showPage:'',
				reloadPath:'',
				baseInfo:{},
				religionList,
				countryList:[],
				mobileErrorText:'',
				emailErrorText:'',
				customizeList:[],
			};
		},
		computed:{
			preferLangCodeList(){
				const { languageTypeList } = this.$bk_Global;
			
				const res = languageTypeList?.filter((item) => {
					let res = ['ch', 'tw', 'en', 'spanish', 'french'];
					if(this.curShop?.countryCode==='jp'){
						res.push('jp');
					}
					return res.includes(item.key);
				});

				return res;
			},
		},
		created (){
			// if(!isInitlanguage){
			// 	isInitlanguage = true;
			// 	this.$bk_switchLang('en');
			// }

			this.verifyPhone = this.$bk_debounce(this.verifyPhone)
			this.verifyEmail = this.$bk_debounce(this.verifyEmail)
		},
		mounted (){
			let { path, query } = this.$route;

			this.reloadPath = `${path}?compId=${query.compId}`;
			
			window.setColorMain('#2E56F2');

			let token = this.$bk_getAccessToken();

			if (this.$bk_isNull(token)) {
				let that = this;
				window.viewCallback = function () {
					that.initData();
				};
				return;
			}
			this.initData();

			
		},
		beforeUnmount (){
			window.setColorMain();
		},
		methods:{
			getLanguageText (){
				let language = this.$bk_getLanguageType();
				let curLanguage = this.$bk_findItem(this.$bk_Global.languageTypeList, language, 'key');
				return curLanguage.label;
			},
			setShowPage (showPage=''){
				this.showPage = showPage;
			},
			initFormData (){
				const { mobileCdCode, mobileCdValue } = this.formData;
				let data = { mobileCdCode, mobileCdValue };

				if(['SANTESPA'].includes(this.curShop.custId)){
					// 新加坡
					data.nationalityCode = 'sg';
				}

				return data;
			},
			async initData (){
				
				this.loadView = 'view';

				await authReq.requestPostSwitchUserLanguage(this, {language: this.$bk_getLanguageType()}).catch(() => {});

				let { language, compId } = this.$route.query;
        
				// if (language && language !== this.$bk_getLanguageType()) {
				// 	language = this.$bk_findObjInList(this.$bk_Global.languageTypeList, 'key', language)?.key || 'en';
				
				// 	this.$store.commit('setItemState', { 'isSwitchLanguage': true });
				// 	this.$bk_switchLang(language);
				// 	location.reload();
				// }

				const curShop = await shopReq.requestGetShopDetailByCompId(this, compId);

				this.curShop = curShop;

				this.formData = this.initFormData();

				this.requestPostDictByTypeCode();
				this.requestGetSystemParamsByCodes();
				this.requestGetBaseAllData();
				this.requestGetRegionList();
				this.requestGetAddMemberConfig()
				this.loadView = '';
			},
			initCustomizeList(){
        let res = [
					{
						key:"base",
						list:[
							{langCode:"bkFirstLast_name", key:'firstName' },
							{langCode:"addCustomerProfile_phoneNumber", key:'mobile' },
							{langCode:"addCustomerProfile_email", key:'email' },
							{ e:'select', langCode:"addCustomerProfile_gender", key:'gender'},
							{ e:'select', langCode:"addCustomerProfile_dateofBirth", key:'birthday'},
							{ e:'select', langCode:"addCustomerProfile_preferredNotificationLanguage", key:'preferLangCode'},
						]
					},
					{
						key:"outer",
						list:[
							{langCode:"addCustomerProfile_insuranceCompany", key:'insuranceCompanyCode'},
							{langCode:"addCustomerProfile_insuranceCardNumber", key:'insuranceCardNo'},
							{e:'select',langCode:"addCustomerProfile_clientSource", key:'arriveSourceCode'},
							{e:'select',langCode:"addCustomerProfile_nationality", key:'nationalityCode'},
							{langCode:"addCustomerProfile_ethnicity", key:'raceText'},
							{e:'select', langCode:"addCustomerProfile_religion", key:'religionCode'},
							{langCode:"addCustomerProfile_idPassport", key:'identityId'},
							{langCode:"addCustomerProfile_emergencyContact", key:'emergency'},
							{langCode:"addCustomerProfile_emergencyContactnumber", key:'emergencyMobile'},
							{langCode:"addCustomerProfile_homeAddress", key:'address'},
							{langCode:"addCustomerProfile_occupation", key:'occupation'},
						]
					},
					{
						key:"social",
						list:[
							{langCode:"addCustomerProfile_whatsApp", key:'whatsApp'},
							{langCode:"addCustomerProfile_facebook", key:'facebook'},
							{langCode:"addCustomerProfile_Ins", key:'instagram'},
							{langCode:"addCustomerProfile_weChat", key:'wechatAccount'},        
						]
					}
        ]

        return res
      },
			async requestGetAddMemberConfig(){
        const { compId, custId } = this.curShop;

        let res = await customerReq.requestGetAddMemberConfig(this, { compId, custId });

				let customizeList = this.initCustomizeList()

        this.customizeList = customizeList.filter((item)=>{
					item.list = item.list.filter((obj) => {
						let curItem = this.$bk_findItem(res, obj.key,'field');
						if(curItem?.field){
							obj.sortIndex = curItem.index
							obj.required = curItem.required
							obj.className = obj.required ? 'required' : '';
						}
						return !!curItem?.field
					}).sort((v1,v2)=>{
            return v1.sortIndex - v2.sortIndex
          });
					return item.list.length
        })
      },
			async requestPostDictByTypeCode (){
				const { compId } = this.curShop;

				const resDict = await baseReq.requestPostDictByTypeCode(this, ['intMobileCd']);

				if(compId){
					const resShop = await shopReq.requestGetShopDetailByCompId(this, compId);
					this.formData.mobileCdCode = resShop.countryCode?.toUpperCase() || 'CN';
					this.formData.mobileCdValue = resDict.intMobileCd.find((v) => {
						return v.code === this.formData.mobileCdCode; 
					})?.value; 

					this.formData.emergencyMobileCdValue =this.formData.mobileCdValue;
					this.formData.emergencyMobileCdCode =this.formData.mobileCdCode;
				}

				this.dictInfo = resDict;
			},
			// 批量获取系统参数
			async requestGetSystemParamsByCodes () {
				const { compId, custId } = this.curShop;
				let params = {
					compId, custId,
					paramCodes:[
						'MASE252', // 开启微信推送
						'MASE255', // 启用保险支付
					],
				};
				const res = await baseReq.requestGetSystemParamsByCodes(this, params);
				this.systemInfo = res;
			},
			async requestGetBaseAllData (){
				const { compId, custId } = this.curShop;
				let res = await baseReq.requestGetBaseAllData(this, { compId, custId });
				
				Object.keys(res).forEach((key) => {
					res[key] = (res[key] || []).filter((vItem)=>{
						return vItem.status===1
					});
				});
				this.baseInfo = res;
			},
			// 查询地区
			async requestGetRegionList () {
				const res = await baseReq.requestGetRegionList(this);
				this.countryList = res;
			},
			// 验证
			async validate (){
				const { formData } = this;
				const { firstName, lastName, birthMd, birthYear } = formData;
				let language =  this.$bk_getLanguageType()

				let flatList = this.customizeList?.reduce((current, nextItem)=>{
          current = current.concat(nextItem.list || [])
          return current
        },[])


				for(let i=0; i<flatList.length; i++){
					let { required, key, langCode, e } = flatList[i];

					if(required){
						let newVal = formData[key];

						if(key=='firstName' && this.$bk_isNull(firstName) && this.$bk_isNull(lastName) ){
							this.$bk_message.error({ langCode:'addCustomerProfile_msg_pleaseEnterName'});
							return false;
						};

						if(key=='birthday'){
							if(this.$bk_isNull(birthMd)){
								this.$bk_message.error({ langCode:'addCustomerProfile_msg_birthMd'});
								return false;
							}

							if(this.$bk_isNull(birthYear)){
								this.$bk_message.error({ langCode:'addCustomerProfile_msg_birthYear'});
								return false;
							}
							continue;
						};

						
						if(key==='insuranceCompanyCode' && this.$bk_isNull(newVal)){
							newVal = formData['insuranceCompanyText'];
						}
						
						let msg = this.$bk_lang[langCode];

						if(e==='select'){
							msg = `${this.$bk_lang['select_def_placeholder']}${['ch','tw'].includes(language) ? '' : ' '}${msg}`
						}else {
							msg = `${this.$bk_lang['input_def_placeholder']}${['ch','tw'].includes(language) ? '' : ' '}${msg}`
						}

						if(this.$bk_isNull(newVal)){
							this.$bk_message.error(msg);
							return false;
						}
					}
				}
		
				return true;
			},
			// 处理提交参数
			getSubmitParams (){
				const { compId, custId } = this.curShop;

				const params = {
					compId, custId,
					...this.formData, 
				};

				if(params.nationalityCode){
					params.nationalityText = this.$bk_findItem(this.countryList, params.nationalityCode, 'code').name;
				}

				if(params.religionCode){
					params.religionText = this.$bk_lang[this.$bk_findItem(this.religionList, params.religionCode).langCode];
				}

				if(params.birthMd){
					params.birthMd = dayjs(params.birthMd).format('MM-DD')
				}
			
				return params;
			},

			// 校验手机号是否已经存在
			verifyPhone (){
				const {mobile, mobileCdCode} = this.formData;
				if(!mobile){
					this.mobileErrorText = '';
					return;
				}

				const { compId, custId } = this.curShop;
				customerReq.getEmailOrMobileIsExist(this, { compId, custId, mobile, mobileCdCode}).then((res=[]) => {
					if(res.length>0){
						// 	const target = res.find((item) => {
						// 		return item.mobile === mobile && item.mobileCdCode === mobileCdCode;
						// 	});
						// 	if(target){
						this.mobileErrorText = this.$bk_lang['addCustomerProfile_mobileExist'];
						return;
						// }
					}
					this.mobileErrorText = '';
				}).catch(() => {
					this.mobileErrorText = '';
				});
			},
			// 校验邮箱是否已经存在
			verifyEmail (){
				const { compId, custId } = this.curShop;
				const {email} = this.formData;
				if(!email){
					this.emailErrorText = '';
					return;
				}
				customerReq.getEmailOrMobileIsExist(this, { compId, custId, email}).then((res=[]) => {
					if(res.length>0) {
						// const target = res.find((item) => {
						// 	return item.email === email;
						// });
						// if(target){
						this.emailErrorText = this.$bk_lang['addCustomerProfile_emailExist'];
						return;
						// }
					}
					this.emailErrorText = '';
				}).catch(() => {
					this.emailErrorText = '';
				});
			},
		
			// 提交
			async handleSave (){

				if(!await this.validate()){
					return false;
				}

				if (this.mobileErrorText) {
					this.$bk_message.error(this.mobileErrorText);
					return false;
				}
				if (this.emailErrorText) {
					this.$bk_message.error(this.emailErrorText);
					return false;
				}
				
				const params = this.getSubmitParams();

				this.loadView = 'save';

				customerReq.requestPostMemberUpdate(this, params).then((res) => {
					this.loadView = '';
					this.formData = this.initFormData();

					this.$bk_message.success({ langCode:'customerleadsForm_msg_addedSuccessfully', duration:4 });

				}).catch(() => {
					this.loadView = '';
				});

			}
		}
	};
</script>

<style lang="less">
@import './addCustomerProfile.less';
</style>